<template>
  <vip :type_client="'communication'" :itemFilter="ruleForUser" />
</template>
<script>
  import Vip from './Vip.vue'

  export default {
    components: { Vip },
    methods: {
      ruleForUser ({ total_deposit }) {
        return total_deposit >= 700
      }
    }
  }
</script>
